<script setup>

    import { computed } from 'vue'
    import ProgressBar from '@/Components/ProgressBar.vue'
    import { IconDocumentArrowUp16Regular } from '@iconify-prerendered/vue-fluent'

    const props = defineProps({
        uploadState: {
            type: Object,
            default: null
    }
    })

    const s = computed(() => props.uploadState)

</script>

<template>
    <div
       v-if="s && s.showInlineUpload === false"
        :ref="(el) => { if (s?.setBelowModuleDropZoneEl) s.setBelowModuleDropZoneEl(el) }"
        :class="[
            'cursor-pointer border border-dashed transition-colors flex w-2/3 justify-center items-center py-6 mx-auto -mt-12 bg-lifeworx-alabaster/25 rounded-b-lg border-t-0 group',
            s.isOverBelowDropZone.value
                ? 'border-slate-600 bg-slate-50'
                : 'border-slate-400 hover:border-slate-500/75 hover:bg-lifeworx-blue-400/10'
        ]"
        @click="s.triggerFileSelect()"
    >
        <div v-if="s.isOverBelowDropZone.value" class="flex items-center justify-center gap-2 py-4 text-lifeworx-blue-600 font-semibold text-sm">
            <IconDocumentArrowUp16Regular class="h-6 w-6" />
            <span>Release to upload</span>
        </div>
        <div v-else-if="s.uploadInProgress.value" class="px-8 py-4">
            <ProgressBar :progress="s.uploadProgress.value" />
        </div>
        <div v-else class="flex items-center justify-center gap-2 py-4 text-lifeworx-blue-600">
            <IconDocumentArrowUp16Regular class="h-6 w-6" />
            <span class="font-semibold text-sm group-hover:underline">Upload a file</span>
            <span class="font-normal text-sm leading-tight text-stone-500">or drag-and-drop it here</span>
        </div>
    </div>

</template>
